import { API_GET_SUBSCRIPTION, API_POST_SUBSCRIPTION } from 'configs/api'
import networkAdapter from 'utilities/networkAdapter'

export const getSubscriptions = async (params: { app_id: string }) => {
  try {
    const response = await networkAdapter.get(API_GET_SUBSCRIPTION, params)
    return response
  } catch (error) {
    throw new Error(`${error}`)
  }
}

export const saveSubscriptions = async (app_id: string, data: any) => {
  try {
    const response = await networkAdapter.post(API_POST_SUBSCRIPTION + `?app_id=${app_id}`, data)
    return response
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('error save subscription', error)
  }
}